import { createContext, useContext } from "react";
import { texts } from "../utils/texts/texts";
import { LANGUAGE } from "../utils/shared/constants";
import { getTypeFromDomain } from "../utils/variations";
import { OrganizationType } from "../models/shared/Organization";
import { texts_sv } from "../utils/texts/texts_sv";
import { texts_cs } from "../utils/texts/texts_cs";
import { getBrowserLanguage } from "../utils/presentation";

export type TextContext = typeof texts;

const getTextFromLanguage = (language: LANGUAGE): TextContext => {
    let finalTexts = texts;
    if (language === LANGUAGE.SV) {
        finalTexts = {
            ...texts,
            ...texts_sv,
        }
    } else if (language === LANGUAGE.CS) {
        finalTexts = {
            ...texts,
            ...texts_cs,
        }
    }
    return finalTexts;
}

const textContext = createContext(getTextFromLanguage(getBrowserLanguage()));

export const useText = () => useContext(textContext);

export const textApplyVariables = (sourceText: string, variables: Record<string, string>) => {
    let finalText = sourceText;

    for (const variable of Object.keys(variables)) {
        finalText = finalText.replace(`{${variable}}`, variables[variable]);
    }

    return finalText;
}

interface UserContextProviderProps {
    children: React.ReactNode;
    language: LANGUAGE;
}

const type = getTypeFromDomain()

export const TextProvider = (props: UserContextProviderProps) => {
    const finalTexts = getTextFromLanguage(props.language);

    if (type === OrganizationType.cgh) {
        finalTexts.brand = finalTexts.brand_cgh;
        finalTexts.brandDescription = finalTexts.brandDescription_cgh;
        document.title = finalTexts.brand;
    }

    return <textContext.Provider value={finalTexts}>
        {props.children}
    </textContext.Provider>
}
